<div class="text-center">
  <h5 class="text-base mb-0"> {{ 'ADMIN.AD_HOC.NO_ADD_HOC' | translate }}</h5>
  <button (click)="adHocModal()" pButton pRipple type="button" icon="fa fa-plus"
  label=" {{ 'ADMIN.AD_HOC.CREATE_AD' | translate }}" class="surface-0 p-button-outlined text-sm mt-3 mb-5"></button>
  <div><img src="/assets/img/trial-empty-img.svg" alt="{{ 'ADMIN.AD_HOC.NO_ADD_HOC' | translate }}" /></div>
</div>